/* "Load more" for collection grids.
   The button is a real link to the next page, so without JavaScript (and for
   search engines) it's plain pagination. With JavaScript, clicking it fetches
   the next page's grid through the Section Rendering API and appends it,
   keeping the active filters and sort order, which are already in the link.
   When a shopper opens a product and comes back, the same pages are reloaded
   and the scroll position is restored. */
(function () {
  var STORE_PREFIX = 'ba-load-more:';

  function container() {
    return document.querySelector('[data-ba-load-more]');
  }

  function storeKey() {
    return STORE_PREFIX + window.location.pathname + window.location.search;
  }

  function fillTemplate(template, shown, total) {
    return template.replace('[shown]', shown).replace('[total]', total);
  }

  function fetchPage(url, sectionId) {
    var requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    return fetch(requestUrl.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  /* Appends the fetched page's products and moves the button on to the page
     after it, or switches to the "all products shown" state. Returns the first
     newly added product card, or null. */
  function appendPage(doc) {
    var grid = document.getElementById('product-grid');
    var current = container();
    var incoming = doc.querySelector('[data-ba-load-more]');
    if (!grid || !current) return null;

    var firstNew = null;
    doc.querySelectorAll('#product-grid > .grid__item').forEach(function (item) {
      item.classList.add('scroll-trigger--cancel');
      grid.appendChild(item);
      if (!firstNew) firstNew = item;
    });

    var shown = grid.querySelectorAll(':scope > .grid__item').length;
    var total = current.dataset.total;
    var status = current.querySelector('.ba-load-more__status');
    var button = current.querySelector('.ba-load-more__button');
    var nextButton = incoming && incoming.querySelector('.ba-load-more__button');

    if (incoming) current.dataset.page = incoming.dataset.page;

    if (nextButton && button) {
      button.href = nextButton.getAttribute('href');
      status.textContent = fillTemplate(current.dataset.statusTemplate, shown, total);
    } else {
      if (button) button.remove();
      status.textContent = fillTemplate(current.dataset.endText, shown, total);
    }
    return firstNew;
  }

  function loadNext(button) {
    var current = container();
    if (!current || button.getAttribute('aria-disabled') === 'true') return Promise.resolve(null);
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    return fetchPage(button.href, current.dataset.sectionId)
      .then(appendPage)
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ba-load-more] .ba-load-more__button');
    if (!button) return;
    event.preventDefault();
    var href = button.href;
    loadNext(button)
      .then(function (firstNew) {
        /* The button disappears on the last page, so keyboard focus moves to
           the first product that was just added. */
        if (firstNew && !document.body.contains(button)) {
          var link = firstNew.querySelector('a');
          if (link) link.focus();
        }
      })
      .catch(function () {
        window.location.href = href;
      });
  });

  /* Remember how far the shopper got, so Back from a product page restores it. */
  window.addEventListener('pagehide', function () {
    var current = container();
    if (!current) return;
    try {
      var page = parseInt(current.dataset.page, 10) || 1;
      if (page > 1) {
        sessionStorage.setItem(storeKey(), JSON.stringify({ page: page, y: window.scrollY }));
      } else {
        sessionStorage.removeItem(storeKey());
      }
    } catch (e) {}
  });

  function restore() {
    var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!navigation || navigation.type !== 'back_forward') return;

    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(storeKey()));
    } catch (e) {}
    var current = container();
    if (!saved || !current || saved.page <= (parseInt(current.dataset.page, 10) || 1)) return;

    var canControlScroll = 'scrollRestoration' in history;
    if (canControlScroll) history.scrollRestoration = 'manual';

    function finish() {
      window.scrollTo(0, saved.y);
      if (canControlScroll) history.scrollRestoration = 'auto';
    }

    function step() {
      var button = current.querySelector('.ba-load-more__button');
      if (!button || (parseInt(current.dataset.page, 10) || 1) >= saved.page) {
        finish();
        return;
      }
      loadNext(button).then(step, finish);
    }
    step();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
